export const PERMISSION_REGISTRY = [
  {
    module: 'dashboard',
    label: 'Dashboard',
    actions: [
      { key: 'view', label: 'View Dashboard' }
    ]
  },
  {
    module: 'vendors',
    label: 'Vendors',
    actions: [
      { key: 'view', label: 'View Vendors' },
      { key: 'add', label: 'Add Vendor' },
      { key: 'edit', label: 'Edit Vendor' },
      { key: 'delete', label: 'Delete Vendor' },
      { key: 'export', label: 'Export Vendors' },
      { key: 'impersonate', label: 'Access Vendor Portal' },
      { key: 'view_leads', label: 'View Vendor Leads' },
      { key: 'extend_validity', label: 'Extend Subscription Validity' },
      { key: 'send_reminder', label: 'Send Subscription Reminder' }
    ]
  },
  {
    module: 'leads',
    label: 'Lead Management',
    actions: [
      { key: 'view', label: 'View Leads' },
      { key: 'add', label: 'Add Lead' },
      { key: 'edit', label: 'Edit Lead' },
      { key: 'delete', label: 'Delete Lead' },
      { key: 'export', label: 'Export Leads' }
    ]
  },
  {
    module: 'customers',
    label: 'Registered Customers',
    actions: [
      { key: 'view', label: 'View Customers' },
      { key: 'delete', label: 'Delete Customer' }
    ]
  },
  {
    module: 'listings',
    label: 'Listing Approvals',
    actions: [
      { key: 'view', label: 'View Listings' },
      { key: 'approve', label: 'Approve Listing' },
      { key: 'reject', label: 'Reject Listing' }
    ]
  },
  {
    module: 'blogs',
    label: 'Blog Management',
    actions: [
      { key: 'view', label: 'View Blogs' },
      { key: 'add', label: 'Add Blog' },
      { key: 'edit', label: 'Edit Blog' },
      { key: 'delete', label: 'Delete Blog' }
    ]
  },
  {
    module: 'webpages',
    label: 'Web Pages',
    actions: [
      { key: 'view', label: 'View Web Pages' },
      { key: 'add', label: 'Add Page/Section' },
      { key: 'edit', label: 'Edit Page/Section' },
      { key: 'delete', label: 'Delete Page/Section' }
    ]
  },
  {
    module: 'plans',
    label: 'Plan Management',
    actions: [
      { key: 'view', label: 'View Plans' },
      { key: 'add', label: 'Add Plan' },
      { key: 'edit', label: 'Edit Plan' },
      { key: 'delete', label: 'Delete Plan' }
    ]
  },
  {
    module: 'settings',
    label: 'Settings',
    actions: [
      { key: 'view', label: 'View Settings' },
      { key: 'edit', label: 'Edit Settings' }
    ]
  },
  {
    module: 'trash',
    label: 'Trash & Soft Delete',
    actions: [
      { key: 'view', label: 'View Trash' },
      { key: 'restore', label: 'Restore Data' },
      { key: 'delete', label: 'Permanent Delete' }
    ]
  },
  {
    module: 'employees',
    label: 'Employee Management',
    actions: [
      { key: 'view', label: 'View Employees' },
      { key: 'add', label: 'Add Employee' },
      { key: 'edit', label: 'Edit Employee' },
      { key: 'delete', label: 'Delete Employee' },
      { key: 'reset_password', label: 'Reset Password' },
      { key: 'change_status', label: 'Activate/Deactivate' }
    ]
  },
  {
    module: 'master_roles',
    label: 'Master Roles & Permissions',
    actions: [
      { key: 'view', label: 'View Roles' },
      { key: 'add', label: 'Add Role' },
      { key: 'edit', label: 'Edit Role' },
      { key: 'delete', label: 'Delete Role' }
    ]
  }
];
